import { createSelector } from 'reselect'

const selectStepseData = (state) => state.steps

export const selectRoute = () => createSelector(
    selectStepseData,
    (Data) => { 
        return Data.routeInfo
    }
)

export const selectStepsItems = () => createSelector(
    selectStepseData,
    (Data) => { 
        return Data.items
    }
)

export const selectStepsId = () => createSelector(
    selectStepseData,
    (Data) => { 
        return Data.stepId
    }
)

export const selectStepsEdges = () => createSelector(
    selectStepseData,
    (Data) => { 
        const edges = []
        Data.relations.map((line) => {

            if (line.start[0] && line.end[0]) edges.push({props: {id:`${line.start[0]}${line.end[0]}`, start:line.start[0].toString(), end:line.end[0].toString()}})
        })

        return edges
    }
)

export const selectStepsFetchLoading = () => createSelector(
    selectStepseData,
    (Data) => Data.loading
)

export const selectStepsFetchUrl = () => createSelector(
    selectStepseData,
    (Data) => Data.url
)


export const selectStepsFetchErrors = () => createSelector(
    selectStepseData,
    (Data) => {
        const validations = {}
        const errorText = ""

        if (Data.errors) {
            if (Data.errors !== null 
                && typeof (Data.errors.non_field_errors) !== 'undefined'
                && typeof (Data.errors.non_field_errors) !== 'string'
            ) {
                let html = ''

                Data.errors.non_field_errors.map((val) => {
                    html += val.message
                })

                errorText = html
            } else if (Object.keys(Data.errors).length > 0) {
                for (const k in Data.errors) {
                    validations[k] = Data.errors[k][0]
                }
            }
        }

        return {validations, errorText}
    }
)


export const selectAddStepLoading = () => createSelector(
    selectStepseData,
    (Data) => Data.adding.loading
)

export const selectAddStepIsDone = () => createSelector(
    selectStepseData,
    (Data) => Data.adding.isDone
)

export const selectAddStepErrors = () => createSelector(
    selectStepseData,
    (Data) => {
        const validations = {}
        const errorText = ""


        if (Data.adding.errors) {
            if (Data.adding.errors !== null 
                && typeof (Data.adding.errors.non_field_errors) !== 'undefined'
                && typeof (Data.adding.errors.non_field_errors) !== 'string'
            ) {
                let html = ''

                Data.adding.errors.non_field_errors.map((val) => {
                    html += val.message
                })

                errorText = html
            } else if (Object.keys(Data.adding.errors).length > 0) {
                for (const k in Data.adding.errors) {
                    validations[k] = Data.adding.errors[k][0]
                }
            }
        }

        return {validations, errorText}
    }
)


export const selectUpdateStepLoading = (id) => createSelector(
    selectStepseData,
    (Data) => (Data.updating[id] && Data.updating[id].loading ? Data.updating[id].loading : false)
)

export const selectUpdateStepIsDone = (id) => createSelector(
    selectStepseData,
    (Data) => (Data.updating[id] && Data.updating[id].isDone ? Data.updating[id].isDone : false)
)

export const selectUpdateStepErrors = (id) => createSelector(
    selectStepseData,
    (Data) => {
        const validations = {}
        const errorText = ""

        if (Data.updating[id] && Data.updating[id].errors) {
            if (Data.updating[id].errors !== null 
                && typeof (Data.updating[id].errors.non_field_errors) !== 'undefined'
                && typeof (Data.updating[id].errors.non_field_errors) !== 'string'
            ) {
                let html = ''

                Data.updating[id].errors.non_field_errors.map((val) => {
                    html += val.message
                })

                errorText = html
            } else if (Object.keys(Data.updating[id].errors).length > 0) {
                for (const k in Data.errors) {
                    validations[k] = Data.updating[id].errors[k][0]
                }
            }
        }

        return {validations, errorText}
    }
)


export const selectPublishLoading = (identifier) => createSelector(
    selectStepseData,
    (Data) => (Data.publish[identifier] && Data.publish[identifier].loading ? Data.publish[identifier].loading : false)
)


export const selectPublishErrors = (identifier) => createSelector(
    selectStepseData,
    (Data) => {
        const validations = {}
        const errorText = ""

        if (Data.publish[identifier] && Data.publish[identifier].errors) {
            if (Data.publish[identifier].errors !== null 
                && typeof (Data.publish[identifier].errors.non_field_errors) !== 'undefined'
                && typeof (Data.publish[identifier].errors.non_field_errors) !== 'string'
            ) {
                let html = ''

                Data.publish[identifier].errors.non_field_errors.map((val) => {
                    html += val.message
                })

                errorText = html
            } else if (Object.keys(Data.publish[identifier].errors).length > 0) {
                for (const k in Data.errors) {
                    validations[k] = Data.publish[identifier].errors[k][0]
                }
            }
        }

        return {validations, errorText}
    }
)

export const selectRequestStepDataLoading = (stepId) => createSelector(
    selectStepseData,
    (Data) => (Data.request[stepId] && Data.request[stepId].loading ? Data.request[stepId].loading : false)
)


export const selectRequestStepDataErrors = (stepId) => createSelector(
    selectStepseData,
    (Data) => {
        const validations = {}
        const errorText = ""

        if (Data.request[stepId] && Data.request[stepId].errors) {
            if (Data.publish[stepId].errors !== null 
                && typeof (Data.request[stepId].errors.non_field_errors) !== 'undefined'
                && typeof (Data.request[stepId].errors.non_field_errors) !== 'string'
            ) {
                let html = ''

                Data.request[stepId].errors.non_field_errors.map((val) => {
                    html += val.message
                })

                errorText = html
            } else if (Object.keys(Data.request[stepId].errors).length > 0) {
                for (const k in Data.errors) {
                    validations[k] = Data.request[stepId].errors[k][0]
                }
            }
        }

        return {validations, errorText}
    }
)

export const selectPartnerRoutePanZoom = () => createSelector(
  selectStepseData,
  (Data) => { 
      return Data.routeInfo.productRoutePanZoom
  }
)
